export interface ClientPowerOfAttorney {
    id?: string | null;
    powerOfAttorneyTypeId: string | null;
    partnerPracticeReference: string | null;
    rightLegalReference: string | null;
    signatureDate?: string | Date | null;
    attorney1: string | null;
    attorney2: string | null;
    attorney3: string | null;
    attorney4: string | null;
    isRegistered: boolean;
    hasChoicesIWouldMakeForm: boolean;
    version?: number | null;
}

export function createClientPowerOfAttorney(): ClientPowerOfAttorney {
    return {
        powerOfAttorneyTypeId: null,
        partnerPracticeReference: null,
        rightLegalReference: null,
        signatureDate: null,
        attorney1: null,
        attorney2: null,
        attorney3: null,
        attorney4: null,
        isRegistered: false,
        hasChoicesIWouldMakeForm: false,
    };
}
